export class LoginRequest {
  username: string;
  userpassword: string;
  secureBrowserToken: string;

  constructor(username: string, userpassword: string, secureBrowserToken: string) {
    this.username = username;
    this.userpassword = userpassword;
    this.secureBrowserToken = secureBrowserToken;
  }
}

// Login Response
export class AuthUser {
  userId: number;
  benutzer: string;
  username: string;
  token: string;
  refreshToken: string;

  constructor() {
    this.userId = 0;
    this.benutzer = '';
    this.username = '';
    this.token = '';
    this.refreshToken = '';
  }
}

export class LogoutRequest {
  refreshtoken: string;

  constructor(token: string) {
    this.refreshtoken = token;
  }
}

export class RefreshLoginRequest {
  refreshtoken: string;

  constructor(token: string) {
    this.refreshtoken = token;
  }
}

export interface LoginConfig {
  userLoginEnabled: boolean;

  azureLoginEnabled: boolean;
  azureClientId: string;
  azureAuthority: string;

  keycloakLoginEnabled: boolean;
  keycloakClientId: string;
  keycloakAuthority: string;
  keycloakRealm: string;
}

export class ExternalLoginRequest {
  idToken: string;
  username: string;

  constructor(idToken: string, username: string) {
    this.idToken = idToken;
    this.username = username;
  }
}
